function editText() {
    if (1 === this.selectedNodes.size) {
        const [node] = [...this.selectedNodes]
        const text = this.getNodeText(node)
        this.startEditNodeText(node, text)
    }
}

export default {
    'F2': editText,
}
